import {
  InjectionToken
} from '@angular/core';
import { ModalOptions } from './modal-options';
import type {
  ComponentRef,
  EmbeddedViewRef,
  TemplateRef
} from '@angular/core';
import type { ComponentPortal, TemplatePortal, ComponentType } from '@angular/cdk/portal';

export interface ModalContainer {
  id: string;
  options: ModalOptions;
  ariaDescribedBy: string | undefined;
  ariaLabeledBy: string | undefined;
  attachComponentPortal<T>(portal: ComponentPortal<T>): ComponentRef<T>;
  attachTemplatePortal<C>(portal: TemplatePortal<C>): EmbeddedViewRef<C>;
  toggleScreenReaderVisibility(visible: boolean): void;
  openSubModal(templateRef: TemplateRef<unknown>): SubModalRef;
}

/**
 * Close reason values returned when user closes modal using backdrop click or escape button.
 */
export enum ModalCloseReason {
  // user-driven interactions
  BACKDROP_CLICK = 'tdWbModal.backDropClick',
  ESC = 'tdWbModal.escapeKey',
  HEADER_BUTTON = 'tdWbModal.headerButton',

  // app-driven (programmatic) interactions
  RETURN_TO_BACKGROUND_PAGE = 'tdWbModal.returnToBackgroundPage',
  TRANSITION_TO_NEXT_MODAL = 'tdWbModal.transitionToNextModal',

  // flow interactions
  SUCCESS = 'tdWbModal.success'
}

/** Injection token for the modal configuration. */
export const MODAL_CONFIG = new InjectionToken<ModalOptions>('modalOptions', {
  providedIn: 'root',
  factory: (): ModalOptions => new ModalOptions()
});

export type ModalData = Record<string, unknown>;

/** Injection token for the modal data*/
export const MODAL_DATA = new InjectionToken<ModalData>('modalData');

export const MODAL_CONTAINER = new InjectionToken<ComponentType<ModalContainer>>('modalContainer');

export enum ModalHeaderType {
  DEFAULT = 'default',
  LIGHT = 'light'
}

export const MODAL_HEADER_CONFIG = new InjectionToken<ModalHeaderType>('modalHeaderConfig');

export interface SubModalRef {
  close(): void;
}
